// src/features/cart/api/clearCart.js
import { axios } from 'lib/axios';
import { queryClient } from 'lib/react-query';
import { useMutation } from 'react-query';
import { useNotificationStore } from 'stores/notifications';

export const clearCart = () => {
  return axios.delete('/cart/clear');
};

export const useClearCart = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation({
    mutationFn: clearCart,
    onSuccess: () => {
      queryClient.invalidateQueries('cart');
      addNotification({
        type: 'success',
        title: 'Cart cleared',
      });
    },
    onError: () => {
      addNotification({
        type: 'error',
        title: 'Action failed',
        message: 'Could not clear cart. Please try again.',
      });
    },
    ...config,
  });
};
